import { PROCESSING_CODES, PROCESSING_LABELS } from '_constants/processing';
import { PRODUCT_CODES, LINKED_PRODUCT_CODES } from '_constants/products';

export const getProcessingLabel = (processingCode) => {
  const MAP = {
    [PROCESSING_CODES.standard]: PROCESSING_LABELS.standard,
    [PROCESSING_CODES.gold]: PROCESSING_LABELS.starter,
    [PROCESSING_CODES.platinum]: PROCESSING_LABELS.deluxe,
    [PROCESSING_CODES.diamond]: PROCESSING_LABELS.premium,
  };

  return MAP[processingCode] || null;
};

export const createProcessingOptions = ({ prices = {}, fees = {} }) => {
  const llcProductPrice = prices[PRODUCT_CODES.incLLC] || 0;
  const sameDayProductPrice = prices[PRODUCT_CODES.incSameDayProcessing] || 0;
  const stateFee = fees[LINKED_PRODUCT_CODES.incStateIncorporationFee];

  return [
    {
      title: `Expedited LLC Processing (Same Day)`,
      price: llcProductPrice + sameDayProductPrice,
      fee: stateFee,
      value: PRODUCT_CODES.incSameDayProcessing,
    },
    {
      title: `Standard LLC Processing (1-4 Business Days)`,
      price: llcProductPrice,
      fee: stateFee,
      value: null,
    },
  ];
};
